import { type ReactNode } from 'react';
import { cn } from '@/lib/cn';

interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  description?: ReactNode;
  action?: ReactNode;
  className?: string;
}

export function EmptyState({ icon, title, description, action, className }: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center text-center py-12 px-4',
        className,
      )}
    >
      {icon && (
        <div className="size-12 rounded-2xl bg-bg-inset border border-border flex items-center justify-center mb-4 text-fg-subtle">
          {icon}
        </div>
      )}
      <div className="text-sm font-medium text-fg">{title}</div>
      {description && <div className="text-xs text-fg-muted mt-1.5 max-w-xs">{description}</div>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
